import isBrowser from"./isBrowser";export const isServer=!isBrowser;export default isServer;